import React from "react";
import {createRoot} from "react-dom/client";
import {HashRouter} from "react-router-dom";
import {App} from "@/app/App";
import {ApiClient} from "@/api/ApiClient";
import {QueryClient, QueryClientProvider} from "@tanstack/react-query";

window.addEventListener("load", async () => {
    await ApiClient.instance.loadFromLocalStorage();

    const root = createRoot(document.getElementById("root")!);

    const queryClient = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                retry: 1,
                staleTime: 1000 * 60 * 5,
            },
        },
    });

    root.render(
        <React.StrictMode>
            <HashRouter>
                <QueryClientProvider client={queryClient}>
                    <App/>
                </QueryClientProvider>
            </HashRouter>
        </React.StrictMode>
    );
});
